// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-field-rating .ui-field-rating-items{display:flex}.ui-field-rating .ui-field-rating-items .star{transition:transform 200ms;margin:5px;cursor:pointer}.ui-field-rating .ui-field-rating-items .star::after{content:\"☆\"}.ui-field-rating .ui-field-rating-items .star.selected::after{content:\"★\"}.ui-field-rating .ui-field-rating-items .star:hover{transform:scale(1.8)}", ""]);
// Exports
module.exports = exports;
